<template>
    <div>
        <menu-bar></menu-bar>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/planos-internet"><i class="fa fa-suitcase" aria-hidden="true"></i> PLANOS DE INTERNET</a></li>
                    <li class="active">CADASTRO DE PLANOS DE INTERNET</li>
                </ol>

                <div class="col-md-3">
                    <planos-internet-menu :ponto_id="plano_internet_id"></planos-internet-menu>
                </div>

                <div class="col-md-9" v-if="plano_internet">
                    <router-view></router-view>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { PlanosInternetMenu } from "../../../components/exports";
import planosInternetMixin from "../../mixins/planos_internet";
import planosInternetComputedMixin from "../../mixins/planos_internet_computed";
export default {
    components: { PlanosInternetMenu },
    mixins: [planosInternetMixin, planosInternetComputedMixin]
};
</script>
